import { render, staticRenderFns } from "./mallExchange.vue?vue&type=template&id=51681134&scoped=true&"
import script from "./mallExchange.vue?vue&type=script&lang=js&"
export * from "./mallExchange.vue?vue&type=script&lang=js&"
import style0 from "./mallExchange.vue?vue&type=style&index=0&id=51681134&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51681134",
  null
  
)

export default component.exports